export enum MeasureType {
  Pressure = 'Pressure',
  StaticPressure = 'StaticPressure',
  ResidualPressure = 'ResidualPressure',
  NominalPressure = 'NominalPressure',
  FlowRate = 'FlowRate',
  PoolingVolume = 'PoolingVolume',
  WaterFlowPressure = 'WaterFlowPressure',
  DeclaredPressure = 'DeclaredPressure',
  MeasuredPressure = 'MeasuredPressure',
  RotationSpeed = 'RotationSpeed'
}
